const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  image: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
      width: '100%',
      height: 'auto',
      marginBottom: theme.spacing(2),
    },
  },
  priceBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  price: {
    ...theme.typography.h1,
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
  },
  pricePrefix: {
    color: 'inherit',
    fontSize: '1.3rem',
    fontWeight: 'inherit',
    marginRight: theme.spacing(1),
  },
  titlePlans: {
    marginBottom: theme.spacing(1),
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2, 0),
  },
  itemName: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  itemPrice: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  message: {
    fontWeight: theme.typography.fontWeightMedium,
    opacity: 0.8,
  },
})

export default styles
